import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getGroups } from '../../api/groupsApi';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { STATUS } from '../../enums/ENUMS';
import { GROUP_WITH_SUBGROUP } from '../../enums/TYPES';
import { SortOptions, SortType } from '../../enums/SORT';

type TInitialState = {
  groups: GROUP_WITH_SUBGROUP[];
  status: STATUS;
  total: number;
};

const initialState: TInitialState = {
  groups: [],
  status: STATUS.IDLE,
  total: 0,
};

export const getGroupsThunk = createAsyncThunk(
  API_ROUTES.GROUPS,
  async (data?: {
    search?: string;
    sort: SortType;
    sortOption: SortOptions;
    page?: number;
    limit?: number;
    filter_out_viewers?: boolean;
  }) => {
    const response = await getGroups({
      search: data?.search,
      sort: data?.sort,
      sortOption: data?.sortOption,
      page: data?.page,
      limit: data?.limit,
      filter_out_viewers: data?.filter_out_viewers,
    });
    return response;
  },
);

export const groupsSlice = createSlice({
  name: 'folders',
  initialState,
  reducers: {
    saveGroups: (state, action: PayloadAction<GROUP_WITH_SUBGROUP[]>) => {
      state.groups = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroupsThunk.pending, (state) => {
        state.status = STATUS.LOADING;
      })
      .addCase(getGroupsThunk.fulfilled, (state, action) => {
        state.status = STATUS.IDLE;
        state.groups = action.payload.documents;
        state.total = action.payload.total;
      })
      .addCase(getGroupsThunk.rejected, (state) => {
        state.status = STATUS.FAILED;
      });
  },
});

export const { saveGroups } = groupsSlice.actions;

export default groupsSlice.reducer;
